import messages from '@/messages/fa.json'

export const siteCopy = messages
export type SiteCopy = typeof messages
